import React from 'react'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'

import pointDescImg from 'images/event/point_description_page4.png'
import TitleHeader from 'components/presenters/header/TitleHeader'

export default function PointLayout() {
  const history = useHistory()

  const handleButtonClick = () => {
    history.push('/mypage/point/use')
  }

  return (
    <PointWrapper>
      <TitleHeader title={'포인트 사용'} />
      <PointDescBlock>
        <PointDescImg src={pointDescImg} />
        <EnquiryButtonBlock>
          <EnquiryButton onClick={handleButtonClick}>구매하러 가기</EnquiryButton>
        </EnquiryButtonBlock>
      </PointDescBlock>
    </PointWrapper>
  )
}

const PointWrapper = styled.div`
  width: 100%;
  overflow: hidden;
`

const PointDescBlock = styled.div`
  position: relative;
  width: 100%;
  margin-top: calc(100vw * (51 / 375));
  overflow-y: scroll;
`

const PointDescImg = styled.img`
  width: 100%;
  height: auto;
  object-fit: cover;
`

const EnquiryButtonBlock = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 0 calc(100vw * (25 / 375)) calc(100vw * (30 / 375)) calc(100vw * (25 / 375));
`

const EnquiryButton = styled.button`
  background-color: #ffcf19;
  box-shadow: 0px 0px 20px #eaddb4;
  width: 100%;
  padding: calc(100vw * (21 / 375)) 0;
  text-align: center;
  font-size: calc(100vw * (20 / 375));
  font-weight: 700;
  line-height: calc(100vw * (29 / 375));
  border-radius: 10px;
`
